module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Oblique.3ca0ae85.ttf";